import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { CompanyService } from '../services/company/company.service';
import { NotifyService } from '../services/nofity.service';

@Injectable({
  providedIn: 'root'
})
export class HelperService {
  previousUrl: string = null;
  currentUrl: string = null;
  emailPattern: string =
    '^(([\\w-]+\\.)+[\\w-]+|([a-zA-Z]{1}|[\\w-]{2,100}))@((([0-1]?[0-9]{1,2}|25[0-5]|2[0-4][0-9])\\.([0-1]?[0-9]{1,2}|25[0-5]|2[0-4][0-9])\\.([0-1]?[0-9]{1,2}|25[0-5]|2[0-4][0-9])\\.([0-1]?[0-9]{1,2}|25[0-5]|2[0-4][0-9])){1}|([a-zA-Z0-9]+[\\w-]+\\.)+[a-zA-Z]{2,9})$';
  YouTubeUrlPattern: string = '/^(?:https?:\/\/)?(?:www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/';

  public emojiPattern = /^(?!.*[\uD800-\uDBFF][\uDC00-\uDFFF]).*$/;

  constructor(
    private notifyService: NotifyService,
    private companyService: CompanyService
  ) { }

  normalizeForm(FormValue: FormGroup): FormGroup {
    Object.keys(FormValue.controls).forEach((key: any) => {
      if (typeof FormValue.get(key)?.value == 'string') {
        FormValue.get(key)?.setValue(
          FormValue.get(key)?.value.toString().trim()
        );
      }
    });

    return FormValue;
  }

  whitespaceValidator(control: any) {
    if (typeof control.value != 'string') return null;

    const isWhitespace = (control.value || '').trim().length === 0;
    return !isWhitespace ? null : { required: true };
  }

  GetErrorsFromFormGroup(formgroup: FormGroup, errorMapping: any) {
    // debugger;
    var Errors: any = [];
    Object.keys(formgroup.controls).forEach((key) => {
      const controlErrors: any = formgroup.get(key)?.errors;
      if (controlErrors != null)
        Object.keys(controlErrors).forEach((keyError) => {
          Errors.push(errorMapping[key][keyError]);
        });
    });
    if (Errors.length > 0) this.notifyService.showWarning(Errors[0]);

    return Errors;
  }

  getAllFilters(filterObj: any): any[] {
    var PostFilter = [];
    Object.keys(filterObj).forEach((key: any) => {
      if ((filterObj[key] != "" && filterObj[key] || filterObj[key] == 0)) {
        PostFilter.push({
          key: key,
          value: filterObj[key],
          operator: "=",
        });
      }
    });
    return PostFilter;
  }

  onlyAlphabets(event: any) {
    const pattern = /^[A-Za-z/-/&/(/)// ]+$/;
    let inputChar = String.fromCharCode(event.charCode);
    if (!pattern.test(inputChar)) event.preventDefault();
  }
  onlyNumbers(event: any) {
    const pattern = /^[0-9/.]+$/;
    let inputChar = String.fromCharCode(event.charCode);
    if (!pattern.test(inputChar)) event.preventDefault();
  }

  onlyAlphanumeric(event: any) {
    const pattern = /^[A-Za-z0-9/-/& ]+$/;
    let inputChar = String.fromCharCode(event.charCode);
    if (!pattern.test(inputChar)) event.preventDefault();
  }


  // async checkUserCompany(ids, companyList) {
  //   var idArr = [];

  //   ids.forEach(element => {
  //     if (companyList.find(x => x.id == element)) {
  //       idArr.push(element);
  //       this.questionIds.push({ id: element, isUserComp: true });
  //     } else this.questionIds.push({ id: element, isUserComp: false });
  //   });
  //   return idArr;
  // }

  truncateString(input: string, maxLength: number): string {
    // Check if the input string is longer than the max length
    if (input && input.length > maxLength) {
      return input.substring(0, maxLength) + '...'; // Truncate and append "..."
    } else {
      return input; // Return the string as is if it's not longer than maxLength
    }
  }
  
}
